export const title = {
  id: `Terima Kasih atas Konfirmasi Kehadiran Anda`,
  en: `Thank You for Your Confirmation`,
};

export const txtTitle = {
  id: `Kehadiran Bapak/Ibu/Saudara/i akan sangat berarti bagi kami. Meski demikian, penting bagi kita semua untuk tetap saling menjaga kesehatan dengan menerapkan protokol kesehatan berikut:`,
  en: `Dear Mr/Mrs/Ms, your presence will mean a lot to us. But in other sides, it’s also important to us that everyone stays safe. Please read the Covid-19 protocols to make us aware in taking care each other:`,
};